<template>
    <div class="container">
        <div class="row">
                <div>
                    <h1 class="titulo">IEH APR</h1>

                    <p class="justifi px-5" style="margin-top: 30px;">Es un sistema de desarrollo para el monitoreo y control de pozos profundos y almacenamiento de agua para comités de agua potable rural.</p>
                    
                    <p class="justifi px-5 espacio">Este sistema trabaja de forma automatizada, para optimizar el funcionamiento y evitar los desabastecimientos de agua y rebalse de estanques.</p>
                    
                    <p class="justifi px-5 espacio">IEH Pozos se encarga de capturar toda la información del pozo y estanque en tiempo real y la podrás visualizar a través de la plataforma www.iehcontrol.com.</p>
                    
                    <p class="justifi px-5 espacio">¿Qué permite medir o controlar?</p>
        
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-1"></div>
                <div class="col-10">
                    <div class="row new-t">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">Variable</div>
                                <div class="col-3">Básica</div>
                                <div class="col-3">Avanzada</div>
                            </div>
                        </div>
                        <div class="col-12 new-tbody">
                            <div class="row">
                                <div class="col-6 justifi">Monitoreo de caudal pozo.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Totalizador de litros extraídos pozo.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Monitoreo de nivel freático pozo.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Monitoreo  de equipo de bombeo pozo.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Datalogger para respaldo de información.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Control de encendido y apagado manual.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Control automatizado de hora punta.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Nivel de llenado de estanque.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Alertas de tiempo de trabajo on/off y falla de motor.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Sensor de presión de matriz(tubería).</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Reportes diarios.</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Múltiples usuarios.</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Monitoreo de variables eléctricas.</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Interacción con variador de frecuencia.</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Pantalla de interfaz en caseta.</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Caudalómetros con lectura inalámbrica de consumos.</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>
            <br>
    </div>
    <br>
    <!-- <div>
        <img src=" assets/images/other/IEH-caudal.png" alt="" class="med">
    </div> -->
</template>
    <style>
        .justifi{
            text-align: justify;
        }
        .justifi2{
            text-align: justify;
            font-family: Arial, Helvetica, sans-serif !important; 
            font-weight: 0px !important;
            color: #2c3e50 !important;
            margin-left: 14px;
        }
        .new-t{
            border: solid 2px #1B2C85;
            border-radius: 18px;
        }
        .new-tbody{
            border-top: solid 2px #1B2C85;
        }
        .new-tbody > div{
            border-top: solid 1px gray;
        }
        .new-tbody > div > div + div{
            border-left: solid 2px #1B2C85;
        }
        
        .med{
            width: 100%;
            height: 100%;
        }

        .espacio{
            margin-top: 8px;
            margin-top: 8px;
        }

        .titulo{
            margin-top: 30px;
        }
        
    </style>
<script>
</script>